type SLUser = {
	id: string;
	email: string;
	fullName: string;
}

type SLResponse = {
	[id: string]: SLUser;
}

export class ServiceLayerClient {
	private readonly baseUrl = "/data";

	public async getInternalEmail(): Promise<string> {
		const user = await this.getUser('436851');

		return user.email;
	}

	private async getUser(id: string): Promise<SLUser> {
		try {
			const response = await fetch(`${this.baseUrl}/cms-users/all/${id}/`);
			if (!response.ok) {
				throw new Error(`Servicelayer response failed: ${response.statusText}`);
			}

			const slResponse = await response.json() as SLResponse;

			return slResponse[id];
		} catch (error) {
			console.error('Failed to fetch user:', error);

			throw error;
		}
	}
}
